import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import basicplanFirstView from '@/assets/images/plans/basicplan-firstview.gif';

function PlansFirstView(): ReactElement {
    const { t } = useTranslation('plans');

    return (
        <div className="flex flex-col lg:min-h-[70vh] lg:flex-row items-center justify-center w-full bg-kotomilThemaColor py-4">
            {/* キャッチコピー */}
            <div className="w-full md:w-1/2 text-3xl lg:text-5xl leading-[1.6] lg:leading-[1.9] tracking-widest mt-4 lg:mt-0 px-10 text-gray-800">
                <p>
                    <span className="inline-block border-b-2 border-gray-600 pb-1">
                        {t('firstView.headline.line1')}
                    </span>
                </p>
                <p className="mt-4 text-3xl lg:text-4xl leading-[1.6] lg:leading-[1.9] text-gray-700">
                    {t('firstView.headline.line2')}
                </p>
            </div>

            {/* 動作画像 */}
            <div className="mt-10 mb-16 px-4 lg:px-8 md:w-1/2">
                <img
                    src={basicplanFirstView}
                    alt={t('firstView.imageAlt')}
                    className="w-full mx-auto rounded-2xl border-4 border-white shadow-lg image-protection"
                />
            </div>
        </div>
    );
}

export default PlansFirstView;
